import './edit-card-category.scss';

import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { ConfirmDialog } from "primereact/confirmdialog";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormCardCategory from "../form-card-category/form-card-category";
import { useEditCardCategory } from "./edit-card-category.hook";

export function EditCardCategory() {
  const {
    cardCategoryData,
    isLoading,
    cardCategoryError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditCardCategory();

  const title =
    cardCategoryData?.name ? <h1>{ cardCategoryData?.name }</h1> : <h1>Edit Card Category</h1>;
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        <FormCardCategory />
      </section>
    </div>
  );

  return (
    <div id="EditCardCategory" className="card-category">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>
      
      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          { cardCategoryError && !isLoading && displayError }
          {!isLoading ? mainContent : null}
         </FormProvider>
      </section>
    </div>
  );
}

export default EditCardCategory;